export default "__VITE_ASSET__D9kQvM0s__"